module.exports = __webpack_public_path__ + "img/others.ebad2f13.jpg";